import {
  centsToDollars,
  dollarsToCents,
  formatCurrencyFromCents,
} from '@/utils/currencyHelpers'
import type { AnnualTaxOutcome } from './annualTaxOutcome.slice'

export type OutcomeFormValues = AnnualTaxOutcome & {
  amount: number | ''
  prefilledFromPreparer: boolean
}

export const getOutcomeFormValues = (
  outcome: AnnualTaxOutcome,
  { extensionModal }: { extensionModal: boolean }
): OutcomeFormValues => {
  const hasCustomerAnswer =
    outcome.isRefund !== null || outcome.amountInCents !== null
  const prefilledFromPreparer =
    !extensionModal &&
    !outcome.notApplicable &&
    !hasCustomerAnswer &&
    outcome.preparerAmountInCents !== null
  const isRefund = prefilledFromPreparer
    ? outcome.preparerIsRefund
    : outcome.isRefund
  const amountInCents = prefilledFromPreparer
    ? outcome.preparerAmountInCents
    : outcome.amountInCents
  return {
    ...outcome,
    isRefund,
    amount: amountInCents === null ? '' : centsToDollars(amountInCents),
    prefilledFromPreparer,
  }
}

/** True while a prefilled row still holds the tax pro's answer, so the note describes what is on screen. */
export const isShowingPreparerFigure = (values: OutcomeFormValues): boolean =>
  values.prefilledFromPreparer &&
  values.isRefund === values.preparerIsRefund &&
  values.amount !== '' &&
  dollarsToCents(values.amount) === values.preparerAmountInCents

export const getPreparerEstimateText = (
  outcome: AnnualTaxOutcome
): string | null => {
  if (outcome.preparerAmountInCents === null) {
    return null
  }
  if (outcome.preparerAmountInCents === 0) {
    return 'Your tax pro estimated no payment is due.'
  }
  return `Your tax pro estimated a payment of ${formatCurrencyFromCents(outcome.preparerAmountInCents)}.`
}
